import { ALLOWED_IMAGE_TYPES } from './image-validation';

export function extractImageFromClipboard(
    clipboardData: DataTransfer | null,
): File | null {
    const items = clipboardData?.items;
    if (!items) return null;

    const allowedMimeTypes = Object.values(ALLOWED_IMAGE_TYPES);
    const clipboardItem = Array.from(items).find(
        (item) => item.kind === 'file' && allowedMimeTypes.includes(item.type),
    );
    return clipboardItem?.getAsFile() ?? null;
}
